<!--
 * @Author: cmchiu
 * @Date: 2023-03-21 15:07:24
 * @LastEditTime: 2023-05-17 12:16:02
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\layout\index.vue
 * 
-->
<template>
    <div class="app-layout">
        <app-header />

        <div class="app-main main-wrapper">
            <router-view :key="key" />
        </div>

        <app-footer />
    </div>
</template>

<script>
import { appHeader } from './AppHeader'
import { appFooter } from './AppFooter'

export default {
    name: 'AppLayout',

    components: { appHeader, appFooter },

    data() {
        return {}
    },

    computed: {
        key() {
            return this.$route.fullPath
        },
    },

    methods: {},
}
</script>

<style scoped lang="scss">
.app-main {
    @media (min-width: 1366px) {
        padding-top: 81px;
    }
    @media (max-width: 1365px) {
        padding-top: 65px;
    }
}
</style>
